// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isDate/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isDate = convertToFP(fn, 1);
export default isDate;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isDate/index.js
// module id = 920
// module chunks = 0